import React from 'react';
import { Link } from 'react-router-dom';
import { DATI_AZIENDA } from './Privacy.jsx';

export default function Contatti() {
  return (
    <main className="min-h-screen bg-white px-6 py-16 text-slate-900">
      <div className="mx-auto max-w-5xl">
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-blue-600">
          Contatti
        </p>

        <h1 className="mt-3 text-4xl font-bold tracking-tight text-slate-950 md:text-5xl">
          Richiedi un intervento o un preventivo.
        </h1>

        <p className="mt-4 max-w-2xl leading-7 text-slate-600">
          Scrivici o chiamaci: raccogliamo i dati dell'impianto e ti richiama un
          tecnico. Per le urgenze il telefono è la strada più rapida.
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-3">
          <a
            href={`mailto:${DATI_AZIENDA.email}`}
            className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-lg"
          >
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
              Email
            </p>
            <p className="mt-3 break-all font-semibold text-slate-950">{DATI_AZIENDA.email}</p>
            <p className="mt-2 text-sm leading-6 text-slate-600">
              Assistenza, preventivi e certificazioni.
            </p>
          </a>

          <a
            href={DATI_AZIENDA.telefonoHref}
            className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-lg"
          >
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
              Telefono
            </p>
            <p className="mt-3 font-semibold text-slate-950">{DATI_AZIENDA.telefono}</p>
            <p className="mt-2 text-sm leading-6 text-slate-600">
              Per interventi urgenti e informazioni rapide.
            </p>
          </a>

          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
              Sede
            </p>
            <p className="mt-3 font-semibold text-slate-950">{DATI_AZIENDA.ragioneSociale}</p>
            <p className="mt-2 text-sm leading-6 text-slate-600">
              {DATI_AZIENDA.indirizzo}
              <br />
              {DATI_AZIENDA.comune}
              <br />
              P. IVA {DATI_AZIENDA.partitaIva}
            </p>
          </div>
        </div>

        <p className="mt-8 text-sm leading-6 text-slate-500">
          I dati che ci invii vengono usati solo per rispondere alla tua richiesta.
          Come li trattiamo è scritto nell'
          <Link to="/privacyPolicy" className="font-semibold text-blue-600 hover:underline">
            informativa privacy e cookie
          </Link>
          .
        </p>
      </div>
    </main>
  );
}
